
import { defineComponent, computed, PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import { TypeCampaignEnum } from '@/types';
import type { FlowStructureType } from '@/types/flow-structure';

export default defineComponent({
  name: 'FlowEmptyState',

  props: {
    type: {
      type: String as PropType<FlowStructureType>,
      required: true,
    },
  },

  emits: ['start-flow'],

  setup(props, { emit }) {
    const { t } = useI18n();

    const iconClass = computed(() => {
      return props.type === TypeCampaignEnum.BULK
        ? 'fa-regular fa-users'
        : 'fa-regular fa-bolt';
    });

    const title = computed(() => {
      return props.type === TypeCampaignEnum.BULK
        ? t('flows.emptyState.bulk.title')
        : t('flows.emptyState.automation.title');
    });

    const description = computed(() => {
      return props.type === TypeCampaignEnum.BULK
        ? t('flows.emptyState.bulk.description')
        : t('flows.emptyState.automation.description');
    });

    const buttonLabel = computed(() => {
      return props.type === TypeCampaignEnum.BULK
        ? t('flows.emptyState.bulk.button')
        : t('flows.emptyState.automation.button');
    });

    const handleStart = () => {
      emit('start-flow', props.type);
    };

    return {
      iconClass,
      title,
      description,
      buttonLabel,
      handleStart,
    };
  },
});
